// extracted by mini-css-extract-plugin
module.exports = {"logo":"ArticleMetaData_logo__qvqBr","time-to-read":"ArticleMetaData_time-to-read__xarAx","section":"ArticleMetaData_section__lRaZO"};